export function parseAccent(e) {
    if (e===null) return null;
    return e.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}


// Taken from Component/Explorer/ExplorerContactList.tsx
export const sortMixedData = (data) => {
  // use duck typing
  return data.sort((a,b)=>{
    let indexA = "name" in a ? a.name.replace('É','E').toUpperCase() : a.lastname.replace('É','E').toUpperCase();
    let indexB = "name" in b ? b.name.replace('É','E').toUpperCase() : b.lastname.replace('É','E').toUpperCase();

    if (indexA > indexB) {
	return 1;
    } else if (indexA < indexB) {
	return -1;
    } else {
	return 0;
    }
  })
}

const prepareSearch = (s) => s === null ? null : parseAccent(s).toUpperCase();
const matchSearch = (s, search) => s && prepareSearch(s).includes(search);

// filter on firstname and lastname or name?
// Taken from Component/Explorer/ExplorerContactList.tsx
export const filterMixedData = (data, raw_search) => {
  const search = prepareSearch(raw_search);

  if (search === "") { return data.slice(); }

  return data.filter((item) => {
      const is_entity  = "name" in item;

     if (is_entity) {
       return (
	 matchSearch(item.name, search) ||
	 matchSearch(item.description, search) ||
	 matchSearch(item.label, search) ||
	 matchSearch(item.alias, search)
       );
     } else {
       return(
	matchSearch(item.lastname, search) ||
	matchSearch(item.firstname, search) ||
	matchSearch(item.biography, search) ||
	matchSearch(item.career, search)
       );
     }
  });
}
